import { DeepLinkStore } from "@/app/model/DeepLinkStore";
import { UiStore } from "@/app/model/UiStore";
import { ProfileStore } from "@/entities/profile/model/ProfileStore";
import { UserStore } from "@/entities/user/model/UserStore";
import { ChatDetailsStore } from "@/features/chat-details/model/ChatDetailsStore";
import { EditDialogStore } from "@/features/edit-dialog/model/EditDialogStore";
import { DialogsStore } from "@/pages/chat/model/DialogsStore";
import { MessageHistoryStore } from "@/pages/chat/model/MessageHistoryStore";
import { MessageSendingStore } from "@/pages/chat/model/MessageSendingStore";
import { ChatOnboardingStore } from "@/pages/chat/model/ChatOnboardingStore";
import { VoiceToTextStore } from "@/pages/chat/model/VoiceToTextStore";
import { AiChatsStore } from "@/pages/home/model/AiChatsStore";
import { VoiceChatStore } from "@/pages/voice-chat/model/VoiceChatStore";
import { ConfirmationModalStore } from "@/shared/model/ConfirmationModalStore";
import { FeatureToggleStore } from "@/shared/model/FeatureToggleStore";
import { SnackbarStore } from "@/shared/model/SnackbarStore";

export interface IRootStore {
  uiStore: UiStore;
  deepLinkStore: DeepLinkStore;
  userStore: UserStore;
  aiChatsStore: AiChatsStore;
  profileStore: ProfileStore;
  dialogsStore: DialogsStore;
  chatDetailsStore: ChatDetailsStore;
  messageSendingStore: MessageSendingStore;
  messageHistoryStore: MessageHistoryStore;
  voiceToTextStore: VoiceToTextStore;
  voiceChatStore: VoiceChatStore;
  featureToggleStore: FeatureToggleStore;
  chatOnboardingStore: ChatOnboardingStore;
  editDialogStore: EditDialogStore;
  confirmationModalStore: ConfirmationModalStore;
  snackbarStore: SnackbarStore;
}

class RootStore implements IRootStore {
  uiStore: UiStore;
  deepLinkStore: DeepLinkStore;
  userStore: UserStore;
  aiChatsStore: AiChatsStore;
  profileStore: ProfileStore;
  dialogsStore: DialogsStore;
  chatDetailsStore: ChatDetailsStore;
  messageSendingStore: MessageSendingStore;
  messageHistoryStore: MessageHistoryStore;
  voiceToTextStore: VoiceToTextStore;
  voiceChatStore: VoiceChatStore;
  featureToggleStore: FeatureToggleStore;
  chatOnboardingStore: ChatOnboardingStore;
  editDialogStore: EditDialogStore;
  confirmationModalStore: ConfirmationModalStore;
  snackbarStore: SnackbarStore;

  constructor() {
    this.uiStore = new UiStore();
    this.deepLinkStore = new DeepLinkStore();
    this.userStore = new UserStore();
    this.aiChatsStore = new AiChatsStore();
    this.profileStore = new ProfileStore();
    this.dialogsStore = new DialogsStore();
    this.chatDetailsStore = new ChatDetailsStore();
    this.messageSendingStore = new MessageSendingStore(this);
    this.messageHistoryStore = new MessageHistoryStore();
    this.voiceToTextStore = new VoiceToTextStore();
    this.voiceChatStore = new VoiceChatStore(this);
    this.featureToggleStore = new FeatureToggleStore();
    this.chatOnboardingStore = new ChatOnboardingStore();
    this.editDialogStore = new EditDialogStore(this);
    this.confirmationModalStore = new ConfirmationModalStore();
    this.snackbarStore = new SnackbarStore();
  }
}

export const rootStore = new RootStore();
